import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { formatValue } from '@/shared/lib/format';
import type { Citation, Panel } from '../api/schemas';
import { PanelFrame } from './PanelFrame';

type Props = { panel: Extract<Panel, { kind: 'forecast' }>; citation: Citation | undefined };

/** OCBC's forecast path, one column per period, exactly as the forecast table prints it. */
export function ForecastPanel({ panel, citation }: Props) {
  return (
    <PanelFrame title={`${panel.instrument} forecast`} meta="OCBC forecast table" citation={citation}>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small" aria-label={`${panel.instrument} forecast by period`}>
          <TableHead sx={{ bgcolor: 'surface.sunken' }}>
            <TableRow>
              {panel.rows.map((r) => (
                <TableCell key={r.period} align="right" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                  {r.period}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ '& td': { borderBottom: 0 } }}>
              {panel.rows.map((r) => (
                <TableCell
                  key={r.period}
                  align="right"
                  sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 500 }}
                >
                  {formatValue(r.value)}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      {panel.note ? (
        <Typography variant="caption" component="p" sx={{ px: 1.75, py: 1, color: 'text.secondary', borderTop: 1, borderColor: 'divider' }}>
          OCBC note: {panel.note}
        </Typography>
      ) : null}
    </PanelFrame>
  );
}
